import { ThemeProperties } from '../../../core';

export interface DescriptionTheme {
	baseFont: string;
	baseTextColor: string;
}
export const theme = new ThemeProperties('description');
